import React from "react";
import { connect } from "react-redux";
import { ShortCutContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Displays, Forms } from "components";

class ShortCutContainer extends React.Component {
  state = {
    isLoading: false,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async (query) => {
    let resArr = await Promise.all([
      portalService.GET_SHORTCUT_LIST(query),
      portalService.GET_ACTIVITY_LIST(`?is_active=true&pagination=false`),
      portalService.GET_ACTIVITY_FORM_LIST(`?is_active=true&pagination=false`),
      portalService.GET_QUESTION_LIST(`?is_active=true&pagination=false`),
    ]);
    if (resArr) {
      this.setState({
        initialValues: { shortcut_list: resArr[0].data.docs },
        activityOptions: resArr[1].data.docs.map((e) => ({
          label: e.name,
          value: e._id,
        })),
        activityFormOptions: resArr[2].data.docs.map((e) => ({
          label: e.name,
          value: e._id,
        })),
        surveyOptions: resArr[3].data.docs.map((e) => ({
          label: e.title,
          value: e._id,
        })),
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  // FLOW SUBMIT
  // =============================
  // =============================
  handleSubmit = async (values) => {
    this.setState({
      isBgLoading: true,
    });
    let resProcess = await Promise.all(
      values.shortcut_list.map((e) => {
        return new Promise(async (resolve) => {
          let params = { ...e };
          delete params._id;
          let res = await portalService.PUT_SHORTCUT_DETAIL(e._id, params);
          if (res && res.status === 200) {
            resolve(true);
          } else {
            resolve(false);
          }
        });
      })
    );
    if (resProcess) {
      toast.success("อัพเดตสำเร็จ");
      this.handleNextStep();
    } else {
      toast.error("อัพเดตไม่สำเร็จ");
    }
  };

  handleNextStep = () => {
    this.setState({
      isBgLoading: false,
    });
    this.props.router.navigate(ROUTE_PATH.FRONTEND_SETTING_SHORT_CUT);
  };

  render() {
    const { authenRedux } = this.props;
    const {
      isLoading,
      initialValues,
      isBgLoading,
      activityOptions,
      activityFormOptions,
      surveyOptions,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "frontend_setting");
    return (
      <ShortCutContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <Forms.ShortcutForm
            initialValues={initialValues}
            activityOptions={activityOptions}
            activityFormOptions={activityFormOptions}
            surveyOptions={surveyOptions}
            permission={permission}
            onSubmit={this.handleSubmit}
          />
        )}
      </ShortCutContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ShortCutContainer));
